import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SalesItem from './SalesItem';
import { DoubleArrowRightIcon } from '../../utilities/icons/CommonIcons';
import AnimatedButton from '../../utilities/AnimatedButton';
import {
  clearRealEstatesFilter,
  setFilters,
} from '../../slices/realEstateSlice';

export default function SalesSection({ realEstateTypes }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigate = () => {
    dispatch(clearRealEstatesFilter());
    navigate('/ventas');
  };

  const handleTypeNavigate = (realEstateTypeId) => {
    dispatch(clearRealEstatesFilter());
    dispatch(setFilters({ realEstateTypeId }));
    navigate('/ventas', { state: { scrollToContent: true } });
  };

  return (
    <div className="m-auto bg-white pb-2 sm:pb-6">
      {/* Título centrado */}
      <motion.div
        className="flex flex-col items-center justify-center py-20 px-4"
        initial={{ opacity: 0, y: 20, scale: 0.95 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <motion.h2
          className="text-2xl sm:text-3xl md:text-4xl tracking-wide font-bold font-heading leading-none text-gray-700 text-center"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        >
          Encuentra el inmueble de tus sueños
        </motion.h2>

        {/* Línea animada más corta con gradiente ida y vuelta */}
        <motion.div
          className="h-1 w-40 mt-4 rounded-full bg-gradient-to-r from-customBlue via-customYellow/50 to-customBlue"
          style={{ backgroundSize: '200% 100%' }}
          animate={{ backgroundPosition: ['0% 0', '100% 0', '0% 0'] }}
          transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
        />
      </motion.div>

      {/* Grid de items */}
      <div className="px-4 sm:px-6 md:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-8 sm:gap-10 md:gap-14 justify-items-center">
          {realEstateTypes.map((realEstateType, index) => (
            <motion.div
              key={index}
              className="w-full rounded-2xl"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.5,
                delay: index * 0.1,
                ease: 'easeOut',
              }}
            >
              <SalesItem
                imageUrl={realEstateType.imageUrl}
                name={realEstateType.name}
                onClick={() => handleTypeNavigate(realEstateType.id)}
              />
            </motion.div>
          ))}
        </div>

        {/* Botón reutilizando AnimatedButton */}
        <motion.div
          className="flex justify-center mt-8 sm:mt-14"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <AnimatedButton
            label="Ver todos los inmuebles"
            onClick={handleNavigate}
            icon={DoubleArrowRightIcon}
          />
        </motion.div>
      </div>
    </div>
  );
}
